import { Skeleton } from "@mui/material";
import { useCallback } from "react";
import type { ServoTypDaten } from "../api";
import { useServoTypDaten } from "../pages/servo-typen/data";
import { useGetOptionLabel } from "./OptionLabel";
import SuspenseBoundary from "./SuspenseBoundary";

export type ServoTypLabelProps = {
  servoTyp: string | ServoTypDaten;
  type?: "primary" | "secondary" | "full";
  secondary?: boolean;
};

export default function ServoTypLabel(props: ServoTypLabelProps) {
  return (
    <SuspenseBoundary fallback={<Skeleton />}>
      <ServoTypLabelInner {...props} />
    </SuspenseBoundary>
  );
}

function ServoTypLabelInner(props: ServoTypLabelProps) {
  return <>{useServoTypLabel(props)}</>;
}

export function useServoTypLabel({
  servoTyp: servoInput,
  type,
}: ServoTypLabelProps): string {
  const servoTyp = useServoTypDaten(servoInput);
  const getInfo = useGetServoTypInfo();

  switch (type) {
    case "primary":
      return servoTyp.produktnummer;
    case "secondary":
      return getInfo(servoTyp);
    default:
      return `${servoTyp.produktnummer} (${getInfo(servoTyp)})`;
  }
}

export function useGetServoTypInfo() {
  const getInterfaceLabel = useGetOptionLabel("servoInterface");

  return useCallback(
    (servoTyp: ServoTypDaten) => getInterfaceLabel(servoTyp.interfaceTyp),
    [getInterfaceLabel]
  );
}
